/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jul 05 2024
 **/

import { makeAPI } from "@/frameworks/core/API/private";
import AdminGroupService from "./api";

export default function withGroupUsers(events: API.Events) {
	return {
		createUser: makeAPI<WebServices.UserAdmin.GroupUser.Add.Response>(
			AdminGroupService.groupUsers.createGroupUser("createUser", events)
		),
		updateUser: makeAPI<WebServices.UserAdmin.GroupUser.Update.Response>(
			AdminGroupService.groupUsers.updateGroupUser("updateUser", events)
		),
		groupUserList: makeAPI<WebServices.UserAdmin.GroupUser.List.Response>(
			AdminGroupService.groupUsers.groupUserList("list", events)
		),
		resetPassword: makeAPI<WebServices.UserAdmin.GroupUser.ResetPassword.Response>(
			AdminGroupService.groupUsers.resetPassword("resetPassword", events)
		),
		unlock: makeAPI<WebServices.UserAdmin.GroupUser.Unlock.Response>(
			AdminGroupService.groupUsers.unlock("unlock", events)
		),
		sendEmail: makeAPI<WebServices.UserAdmin.GroupUser.SendEmail.Response>(
			AdminGroupService.groupUsers.sendEmail("sendEmail", events)
		),
		deleteUser: makeAPI<WebServices.UserAdmin.GroupUser.Delete.Response>(
			AdminGroupService.groupUsers.deleteGroupUser("deleteGroupUser", events)
		),
		detail: makeAPI<WebServices.UserAdmin.GroupUser.UserDetail.Response>(
			AdminGroupService.groupUsers.userDetail("userDetail", events)
		),
		downloadExcelSample: makeAPI<WebServices.UserAdmin.GroupUser.DownloadExcelSample.Response>(
			AdminGroupService.groupUsers.downloadExcelSample("downloadExcelSample", events)
		),
		importExcelUsers: makeAPI<WebServices.UserAdmin.GroupUser.ImportUsers.Response>(
			AdminGroupService.groupUsers.importUsers("importUsers", events)
		)
	};
}
